module.exports = __webpack_public_path__ + "/bundle/asset/admission4-2-30441343eabed9a1316a90ab5ca6905b.png";